import type { MechKey } from './keys';

export const de: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mechanik · 2D',
  'panel.scene': 'Szene',
  'panel.dims': 'Parameter',
  'panel.style': 'Erscheinungsbild',
  'panel.action': 'Steuerung',
  'style.body': 'Körper',
  'style.vector': 'Vektoren',
  'style.ground': 'Boden',
  'style.forces': 'Kräfte anzeigen',
  'style.trace': 'Spur anzeigen',
  'style.labels': 'Vektor-Beschriftungen',
  'hint.line1': 'Auf „Abspielen" klicken · Körper ziehen zum Verschieben',
  'hint.line2': 'Sandbox: Form wählen, dann klicken zum Platzieren',
  'scene.incline': 'Schiefe Ebene',
  'scene.projectile': 'Wurfbewegung',
  'scene.pendulum': 'Pendel',
  'scene.springMass': 'Feder-Masse-System',
  'scene.collisions': 'Kollisionen',
  'scene.atwood': 'Atwood-Maschine',
  'scene.circular': 'Kreisbewegung',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'Winkel (°)',
  'dim.friction': 'Reibung',
  'dim.mass': 'Masse',
  'dim.massA': 'Masse A',
  'dim.massB': 'Masse B',
  'dim.velocity': 'Geschwindigkeit',
  'dim.angleLaunch': 'Abwurfwinkel (°)',
  'dim.gravity': 'Schwerkraft',
  'dim.gravityX': 'Schwerkraft x',
  'dim.gravityY': 'Schwerkraft y',
  'dim.length': 'Länge',
  'dim.damping': 'Dämpfung',
  'dim.spring': 'Steifigkeit',
  'dim.restitution': 'Restitution',
  'dim.radius': 'Radius',
  'dim.speed': 'Schnelligkeit',
  'action.play': 'Abspielen',
  'action.pause': 'Pause',
  'action.step': 'Schritt',
  'action.reset': 'Zurücksetzen',
  'action.speed': 'Geschwindigkeit',
  'action.clear': 'Leeren',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Schwerkraft',
  'forceName.normal': 'Normalkraft',
  'forceName.friction': 'Reibungskraft',
  'forceName.tension': 'Spannung',
  'forceName.spring': 'Federkraft',
  'forceName.applied': 'Angewandte Kraft',
  'forceName.air': 'Luftwiderstand',
  'palette.box': 'Quader',
  'palette.circle': 'Ball',
  'palette.ramp': 'Rampe',
  'palette.ground': 'Boden',
  'palette.hint': 'Form wählen, dann auf die Leinwand klicken zum Platzieren.',
  'panel.forces': 'Beobachtete Kräfte',
  'forces.empty': 'Noch keine — Szene abspielen',
};
